import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  fetchRepository,
  fetchRelatedItem,
  updateItem
} from "../../../../redux/actions/repositoryActions";
import { Box } from "@mui/material";
import {
  enqueueSuccessSnackbar,
  enqueueErrorSnackbar
} from "../../../../redux/actions/snackbarActions";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import RepositoryItemDetails from "./RepositoryItemDetails";
import {
  buildManageRespositoryRoute,
  buildAddRepositoryItemVersionRoute,
  buildManageRepositoryItemRoute
} from "../../../../routes/AdminRoutes";
import { makeGetEntities } from "../../../../redux/selectors/selectors";
import { activityTypes } from "../../../../constants";
import AddRepositoryItemVersionModal from "./AddRepositoryItemVersion/AddRepositoryItemVersionModal";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const ManageRepositoryItem = ({
  match: {
    params: { repositoryId, itemId }
  },
  repositoryItem,
  repository
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentRepositoryItemData, setCurrentRepositoryItemData] = useState(
    repositoryItem
  );
  const [modalItem, setModalItem] = useState(null);
  const [repositoryItemFetched, setRepositoryItemFetched] = useState(false);

  const loading = !repositoryItemFetched || !repositoryItem;

  useEffect(() => {
    setRepositoryItemFetched(false);
    dispatch(
      fetchRelatedItem(repositoryId, itemId, {
        include: "versions,versions.creator,repository,associated_courses"
      })
    ).then(() => {
      setRepositoryItemFetched(true);
    });
  }, [itemId]);

  useEffect(() => {
    dispatch(fetchRepository(repositoryId));
  }, [repositoryId]);

  useEffect(() => {
    if (
      repositoryItem?.associatedCourses &&
      !currentRepositoryItemData?.associatedCourses
    ) {
      setCurrentRepositoryItemData(repositoryItem);
    }
  }, [repositoryItem]);

  const handleCloseAddItemVersionModal = itemId => {
    setModalItem(null);
    dispatch(push(buildManageRepositoryItemRoute(repositoryId, itemId)));
  };

  const handleBackToManageRepositoryView = () => {
    dispatch(push(buildManageRespositoryRoute(repositoryId)));
  };

  const handleAddItem = () => {
    const item = currentRepositoryItemData;
    if (
      item.extendedItemType === activityTypes.quiz ||
      item.extendedItemType === activityTypes.survey ||
      item.extendedItemType === activityTypes.homework
    ) {
      setModalItem(item);
    } else {
      dispatch(push(buildAddRepositoryItemVersionRoute(repositoryId, itemId)));
    }
  };

  const handleGoBackHere = () => {
    dispatch(push(buildManageRepositoryItemRoute(repositoryId, itemId)));
  };

  const handleFieldUpdate = async (field, value, skipSave) => {
    if (!skipSave && currentRepositoryItemData[field] !== value) {
      let data = { ...currentRepositoryItemData };

      data[field] = value;
      setCurrentRepositoryItemData(data);
      const newRepositoryItem = await dispatch(
        updateItem(repositoryItem.id, data)
      );
      if (
        newRepositoryItem &&
        newRepositoryItem.id &&
        !newRepositoryItem.errors
      ) {
        dispatch(
          enqueueSuccessSnackbar({
            message: t("manageRepository.manageItemSuccessMsg")
          })
        );
      } else {
        dispatch(
          enqueueErrorSnackbar({
            message: t("manageRepository.manageItemErrorMsg")
          })
        );
      }
    }
  };

  if (currentRepositoryItemData) {
    const { isLatestVersion } = currentRepositoryItemData;
    const updatesDisabled =
      !isLatestVersion ||
      (currentRepositoryItemData
        ? !currentRepositoryItemData.repository.allowItemsManagement
        : true);
    const repositoryAccessType = currentRepositoryItemData.repository
      ? currentRepositoryItemData.repository.accessType
      : "owned";

    return (
      <Box>
        <RepositoryItemDetails
          repositoryItem={currentRepositoryItemData}
          repository={repository}
          repositoryId={repositoryId}
          itemId={itemId}
          updatesDisabled={updatesDisabled}
          repositoryAccessType={repositoryAccessType}
          onGoBackClick={handleBackToManageRepositoryView}
          onAddItem={handleAddItem}
          onReturnHereClick={handleGoBackHere}
          onUpdateData={handleFieldUpdate}
          loading={loading}
        />
        <AddRepositoryItemVersionModal
          open={!!modalItem}
          onClose={handleCloseAddItemVersionModal}
          existingItem={modalItem}
          existingItemId={modalItem ? modalItem.id : null}
        />
      </Box>
    );
  } else {
    return false;
  }
};

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    const selector = makeGetEntities();
    const repositoryItem = selector(state.repositoryState, {
      type: "items",
      id: props.match.params.itemId
    });
    const repository = selector(state.repositoryState, {
      type: "libraries",
      id: props.match.params.repositoryId
    });
    return {
      repositoryItem,
      repository
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, null)(ManageRepositoryItem);

ManageRepositoryItem.propTypes = {
  repository: PropTypes.object,
  /**
   * The repository item displayed in the page
   */
  repositoryItem: PropTypes.any
};
